const t = {
  name: "CardStack",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.72727 9V11H5V9H9.72727Z" fill="currentColor"/>
<path d="M5 1C3.34315 1 2 2.34315 2 4V12C2 13.6569 3.34315 15 5 15H19C20.6569 15 22 13.6569 22 12V4C22 2.34315 20.6569 1 19 1H5ZM4 12V7H20V12C20 12.5523 19.5523 13 19 13H5C4.44772 13 4 12.5523 4 12ZM4 5V4C4 3.44772 4.44772 3 5 3H19C19.5523 3 20 3.44772 20 4V5H4Z" fill="currentColor"/>
<path d="M2 17H22V19H2V17Z" fill="currentColor"/>
<path d="M2 21H22V23H2V21Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as CardStack
};
